import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { Form, CheckboxWithLabel } from '@grandvisionhq/forms';

const UserForm = ({ labels , formName , onSubmit  })=>{
    const [consent, setConsent] = React.useState(false);
    const [hasFormValidationError, setHasFormValidationError] = React.useState(false);
    const handleConsentChange = ({ checked  })=>{
        setConsent(checked);
    };
    const handleSubmit = ()=>{
        if (consent) {
            setHasFormValidationError(false);
            onSubmit();
            return;
        }
        setHasFormValidationError(true);
    };
    return /*#__PURE__*/ React.createElement(Form, {
        onSubmit: handleSubmit,
        name: formName,
        "data-t": "signup-form",
        showErrorsOnInvalidSubmit: false,
        className: "back-in-stock-modal__form"
    }, /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        "data-t": "consent",
        required: true,
        label: labels.consentMessageWithEmail,
        onChange: handleConsentChange,
        value: "consent",
        checked: consent,
        error: hasFormValidationError,
        errorMessage: labels.inputRequired
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption"
    }, labels.consentMessage));
};

export { UserForm as default };
//# sourceMappingURL=UserForm.js.map
